<email-log-table
  [emailLogTableOptions]="{ hideCheckbox: true }"
  [tableData]="emailLogs$ | async"
  (onClickRow)="onClickRow($event)"
></email-log-table>
